import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TransitionState} from '../transition.component';
import {FormControl, Validators} from '@angular/forms';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit {

  remarkFormControl = new FormControl('', [Validators.maxLength(10000)]);

  @Input()
  utmSource: string;

  addressEnabled: boolean;

  @Input()
  displayCustomerAddress: boolean;
  @Input()
  enableDocuments: boolean;

  @Input()
  set displayAddress(showAddress: boolean) {
    if (showAddress) {
      this.addressEnabled = true;
    } else {
      this.addressEnabled = false;
      this.objectDataValid = true;
    }
  }

  @Input()
  formState: TransitionState;

  @Input()
  isMilesAndMoreCustomer: boolean;
  @Input()
  milesAndMoreServiceNumber: string;

  @Output()
  files: EventEmitter<File[]> = new EventEmitter<File[]>();

  @Output()
  onValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(MatCheckbox)
  private consentCheckbox: MatCheckbox;

  customerDataValid: boolean;

  objectDataValid: boolean;

  constructor() {
  }

  ngOnInit(): void {
    this.remarkFormControl.statusChanges.subscribe(this.checkValidity.bind(this));
  }

  checkValidity() {
    this.onValidChange.emit(this.customerDataValid && this.objectDataValid && this.consentCheckbox?.checked && this.remarkFormControl?.valid);
  }
}
